var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        title: _vm.modalTitle,
        centered: "",
        size: "lg",
        "no-close-on-backdrop": "",
      },
      on: { hide: _vm.closeHandler, shown: _vm.handleModalShown },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "w-100 d-flex justify-content-end" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mr-2",
                      attrs: { variant: "outline-secondary" },
                      on: {
                        click: function ($event) {
                          return _vm.$refs.modal.hide()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            (_vm.salsifyPublishResults &&
                              _vm.salsifyPublishResults.length > 0) ||
                              (_vm.bynderPublishResults &&
                                _vm.bynderPublishResults.length > 0) ||
                              (_vm.walmartPublishResults &&
                                _vm.walmartPublishResults.length > 0)
                              ? "Close"
                              : "Cancel"
                          ) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isSalsify
                    ? _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "primary",
                            disabled: _vm.isPublishing || !_vm.platformId,
                          },
                          on: { click: _vm.handleSalsifyPublish },
                        },
                        [
                          _vm.isPublishing
                            ? _c("b-spinner", {
                                staticClass: "mr-1",
                                attrs: { small: "" },
                              })
                            : _vm._e(),
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.isPublishing
                                  ? _vm.actioningText
                                  : _vm.actionButtonText("Salsify")
                              ) +
                              "\n      "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isBynder
                    ? _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "primary",
                            disabled: _vm.isPublishing || !_vm.platformId,
                          },
                          on: { click: _vm.handleBynderPublish },
                        },
                        [
                          _vm.isPublishing
                            ? _c("b-spinner", {
                                staticClass: "mr-1",
                                attrs: { small: "" },
                              })
                            : _vm._e(),
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.isPublishing
                                  ? _vm.actioningText
                                  : _vm.actionButtonText("Bynder")
                              ) +
                              "\n      "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isWalmart
                    ? _c(
                        "b-button",
                        {
                          attrs: {
                            variant: "primary",
                            disabled: _vm.isPublishing || !_vm.platformId,
                          },
                          on: { click: _vm.handleWalmartPublish },
                        },
                        [
                          _vm.isPublishing
                            ? _c("b-spinner", {
                                staticClass: "mr-1",
                                attrs: { small: "" },
                              })
                            : _vm._e(),
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.isPublishing
                                  ? _vm.actioningText
                                  : _vm.actionButtonText("Walmart")
                              ) +
                              "\n      "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "b-card",
        { staticClass: "mb-3" },
        [
          _c(
            "b-form",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Platform",
                            "label-for": "platform-select",
                            "label-class": "mb-1",
                          },
                        },
                        [
                          _c(
                            "b-form-select",
                            {
                              attrs: { id: "platform-select", size: "sm" },
                              on: { change: _vm.handlePlatformChange },
                              model: {
                                value: _vm.platformId,
                                callback: function ($$v) {
                                  _vm.platformId = $$v
                                },
                                expression: "platformId",
                              },
                            },
                            [
                              _c(
                                "b-form-select-option",
                                {
                                  attrs: {
                                    value: "",
                                    disabled: "",
                                    selected: "",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                Select Platform\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.platforms, function (platform) {
                                return _c(
                                  "b-form-select-option",
                                  {
                                    key: platform.id,
                                    attrs: { value: platform.id },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(platform.name) +
                                        "\n              "
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.selectedItems && _vm.selectedItems.length > 0
                ? _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "b-form-group",
                            {
                              attrs: {
                                label: "Selected file names",
                                "label-class": "mb-1",
                              },
                            },
                            _vm._l(_vm.selectedItems, function (item, index) {
                              return _c(
                                "div",
                                { key: item.id, staticClass: "mb-2" },
                                [
                                  _c("b-form-input", {
                                    attrs: {
                                      id: `file-name-${index}`,
                                      size: "sm",
                                      placeholder: `File ${index + 1} name`,
                                    },
                                    model: {
                                      value: item.name,
                                      callback: function ($$v) {
                                        _vm.$set(item, "name", $$v)
                                      },
                                      expression: "item.name",
                                    },
                                  }),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      (_vm.salsifyPublishResults && _vm.salsifyPublishResults.length > 0) ||
      (_vm.bynderPublishResults && _vm.bynderPublishResults.length > 0) ||
      (_vm.walmartPublishResults && _vm.walmartPublishResults.length > 0)
        ? _c("b-card", { staticClass: "mb-3 border-success" }, [
            _c("div", { staticClass: "d-flex align-items-center mb-3" }, [
              _c("h6", { staticClass: "mb-0 text-success" }, [
                _vm._v("\n        " + _vm._s(_vm.successMessage) + "\n      "),
              ]),
            ]),
            _vm._v(" "),
            _vm.isSalsify
              ? _c(
                  "div",
                  { staticClass: "published-files" },
                  _vm._l(_vm.salsifyPublishResults, function (result) {
                    return _c(
                      "div",
                      {
                        key: result.file_id,
                        staticClass:
                          "published-file-item mb-2 p-2 bg-light rounded",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-between align-items-center",
                          },
                          [
                            _c("div", [
                              _c("strong", [_vm._v(_vm._s(result.file_name))]),
                              _vm._v(" "),
                              _c("div", { staticClass: "text-muted small" }, [
                                _vm._v(
                                  "\n              File ID: " +
                                    _vm._s(result.file_id) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              result.media_id
                                ? _c(
                                    "div",
                                    { staticClass: "text-muted small" },
                                    [
                                      _vm._v(
                                        "\n              Asset ID: " +
                                          _vm._s(result.media_id) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              result.url
                                ? _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn btn-sm btn-outline-primary",
                                      attrs: {
                                        href: result.url,
                                        target: "_blank",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fas fa-external-link-alt mr-1",
                                      }),
                                      _vm._v(
                                        "\n              View on Salsify\n            "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "span",
                                    { staticClass: "badge badge-success" },
                                    [
                                      _vm._v(
                                        "\n              Published\n            "
                                      ),
                                    ]
                                  ),
                            ]),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isBynder
              ? _c(
                  "div",
                  { staticClass: "published-files" },
                  _vm._l(_vm.bynderPublishResults, function (result) {
                    return _c(
                      "div",
                      {
                        key: result.file_id,
                        staticClass:
                          "published-file-item mb-2 p-2 bg-light rounded",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-between align-items-center",
                          },
                          [
                            _c("div", [
                              _c("strong", [_vm._v(_vm._s(result.file_name))]),
                              _vm._v(" "),
                              _c("div", { staticClass: "text-muted small" }, [
                                _vm._v(
                                  "\n              File ID: " +
                                    _vm._s(result.file_id) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              result.media_id
                                ? _c(
                                    "div",
                                    { staticClass: "text-muted small" },
                                    [
                                      _vm._v(
                                        "\n              Asset ID: " +
                                          _vm._s(result.media_id) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c(
                                "span",
                                { staticClass: "badge badge-success" },
                                [
                                  _vm._v(
                                    "\n              Published\n            "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isWalmart
              ? _c(
                  "div",
                  { staticClass: "published-files" },
                  _vm._l(_vm.walmartPublishResults, function (result) {
                    return _c(
                      "div",
                      {
                        key: result.file_id,
                        staticClass:
                          "published-file-item mb-2 p-2 bg-light rounded",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-between align-items-center",
                          },
                          [
                            _c("div", [
                              _c("strong", [_vm._v(_vm._s(result.file_name))]),
                              _vm._v(" "),
                              _c("div", { staticClass: "text-muted small" }, [
                                _vm._v(
                                  "\n              File ID: " +
                                    _vm._s(result.file_id) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              result.message
                                ? _c(
                                    "div",
                                    { staticClass: "text-success small mt-1" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(result.message) +
                                          "\n            "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c(
                                "span",
                                { staticClass: "badge badge-success" },
                                [
                                  _vm._v(
                                    "\n              Published\n            "
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.publishErrors && _vm.publishErrors.length > 0
        ? _c("b-card", { staticClass: "mb-3 border-danger" }, [
            _c("div", { staticClass: "d-flex align-items-center mb-3" }, [
              _c("h6", { staticClass: "mb-0 text-danger" }, [
                _vm._v("\n        Publishing Errors\n      "),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "error-files" },
              _vm._l(_vm.publishErrors, function (error) {
                return _c(
                  "div",
                  {
                    key: error.file_id,
                    staticClass: "error-file-item mb-2 p-2 bg-light rounded",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between align-items-start",
                      },
                      [
                        _c("div", { staticClass: "flex-grow-1" }, [
                          _c("strong", [_vm._v(_vm._s(error.file_name))]),
                          _vm._v(" "),
                          _c("div", { staticClass: "text-muted small" }, [
                            _vm._v(
                              "\n              File ID: " +
                                _vm._s(error.file_id) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          error.media_id
                            ? _c("div", { staticClass: "text-muted small" }, [
                                _vm._v(
                                  "\n              Asset ID: " +
                                    _vm._s(error.media_id) +
                                    "\n            "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "text-danger small mt-1" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(error.error_message) +
                                "\n            "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          error.url
                            ? _c(
                                "a",
                                {
                                  staticClass: "btn btn-sm btn-outline-primary",
                                  attrs: { href: error.url, target: "_blank" },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fas fa-external-link-alt mr-1",
                                  }),
                                  _vm._v(
                                    "\n              View on Salsify\n            "
                                  ),
                                ]
                              )
                            : _c(
                                "span",
                                { staticClass: "badge badge-danger" },
                                [_vm._v("\n              Failed\n            ")]
                              ),
                        ]),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }